"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _excluded = ["theme", "background", "forwardedRef"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Clock = function Clock(_ref) {
  var theme = _ref.theme,
    background = _ref.background,
    forwardedRef = _ref.forwardedRef,
    rest = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    /* eslint-disable */
    _react["default"].createElement("svg", _extends({
      width: "149",
      height: "149",
      viewBox: "0 0 149 149",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: forwardedRef
    }, rest), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M75.1416 124.96C103.595 124.96 126.66 101.894 126.66 73.4413C126.66 44.9884 103.595 21.9227 75.1416 21.9227C46.6887 21.9227 23.623 44.9884 23.623 73.4413C23.623 101.894 46.6887 124.96 75.1416 124.96Z",
      fill: "url(#paint0_linear)"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M75.1412 124.105C103.123 124.105 125.806 101.422 125.806 73.4406C125.806 45.4593 103.123 22.776 75.1412 22.776C47.1599 22.776 24.4766 45.4593 24.4766 73.4406C24.4766 101.422 47.1599 124.105 75.1412 124.105Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M75.1412 124.105C103.123 124.105 125.806 101.422 125.806 73.4406C125.806 45.4593 103.123 22.776 75.1412 22.776C47.1599 22.776 24.4766 45.4593 24.4766 73.4406C24.4766 101.422 47.1599 124.105 75.1412 124.105Z",
      fill: "#424A54"
    }), /*#__PURE__*/_react["default"].createElement("path", _defineProperty({
      d: "M75.1427 113.716C97.3863 113.716 115.418 95.6845 115.418 73.4409C115.418 51.1973 97.3863 33.1653 75.1427 33.1653C52.8992 33.1653 34.8672 51.1973 34.8672 73.4409C34.8672 95.6845 52.8992 113.716 75.1427 113.716Z",
      fill: "#F0F3F7"
    }, "fill", background || theme.clock.background)), /*#__PURE__*/_react["default"].createElement("path", {
      opacity: "0.3",
      d: "M76.281 40.2812H74.0039V75.8604H76.281V40.2812Z",
      fill: "#535461"
    }), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.1"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      opacity: "0.1",
      d: "M109.724 72.5868H77.5605V75.4332H109.724V72.5868Z",
      fill: "black"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      opacity: "0.1",
      d: "M54.8537 61.9378L53.5332 64.4594L73.7708 75.0573L75.0913 72.5358L54.8537 61.9378Z",
      fill: "black"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      opacity: "0.1",
      d: "M75.1425 78.2798C77.5005 78.2798 79.412 76.3683 79.412 74.0103C79.412 71.6523 77.5005 69.7408 75.1425 69.7408C72.7846 69.7408 70.873 71.6523 70.873 74.0103C70.873 76.3683 72.7846 78.2798 75.1425 78.2798Z",
      fill: "black"
    })), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M73.4582 40.3397L72.9805 72.4996L75.8265 72.5419L76.3042 40.3819L73.4582 40.3397Z",
      fill: "#535461"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M76.5158 73.8718L90.3867 55.7203L88.1251 53.9921L74.2542 72.1435L76.5158 73.8718Z",
      fill: "#535461"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M75.1425 77.7106C77.5005 77.7106 79.412 75.799 79.412 73.4411C79.412 71.0831 77.5005 69.1716 75.1425 69.1716C72.7846 69.1716 70.873 71.0831 70.873 73.4411C70.873 75.799 72.7846 77.7106 75.1425 77.7106Z",
      fill: "#535461"
    }), /*#__PURE__*/_react["default"].createElement("g", {
      style: {
        mixBlendMode: 'luminosity'
      },
      opacity: "0.8"
    }, /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M74.3242 0.648071H75.6758V4.70287H74.3242V0.648071Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M74.3242 0.648071H75.6758V4.70287H74.3242V0.648071Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M109.467 135.47L110.637 134.794L112.665 138.306L111.494 138.982L109.467 135.47Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M109.467 135.47L110.637 134.794L112.665 138.306L111.494 138.982L109.467 135.47Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M135.484 110.247L136.221 109.113L139.621 111.322L138.885 112.455L135.484 110.247Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M135.484 110.247L136.221 109.113L139.621 111.322L138.885 112.455L135.484 110.247Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M83.8556 144.326C83.8361 144.14 83.9708 143.974 84.1564 143.955C84.342 143.935 84.5082 144.07 84.5277 144.255L84.8809 147.616C84.9004 147.801 84.7658 147.968 84.5802 147.987C84.3946 148.007 84.2283 147.872 84.2088 147.686L83.8556 144.326Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M83.8556 144.326C83.8361 144.14 83.9708 143.974 84.1564 143.955C84.342 143.935 84.5082 144.07 84.5277 144.255L84.8809 147.616C84.9004 147.801 84.7658 147.968 84.5802 147.987C84.3946 148.007 84.2283 147.872 84.2088 147.686L83.8556 144.326Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M101.71 139.802C101.634 139.631 101.71 139.432 101.881 139.356C102.051 139.28 102.251 139.356 102.327 139.527L103.701 142.614C103.777 142.784 103.701 142.984 103.53 143.06C103.36 143.136 103.16 143.059 103.084 142.889L101.71 139.802Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M101.71 139.802C101.634 139.631 101.71 139.432 101.881 139.356C102.051 139.28 102.251 139.356 102.327 139.527L103.701 142.614C103.777 142.784 103.701 142.984 103.53 143.06C103.36 143.136 103.16 143.059 103.084 142.889L101.71 139.802Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M92.951 142.576C92.909 142.394 93.0224 142.213 93.2042 142.171C93.3861 142.129 93.5675 142.242 93.6095 142.424L94.3696 145.716C94.4116 145.898 94.2982 146.08 94.1164 146.122C93.9345 146.164 93.7531 146.05 93.7111 145.868L92.951 142.576Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M92.951 142.576C92.909 142.394 93.0224 142.213 93.2042 142.171C93.3861 142.129 93.5675 142.242 93.6095 142.424L94.3696 145.716C94.4116 145.898 94.2982 146.08 94.1164 146.122C93.9345 146.164 93.7531 146.05 93.7111 145.868L92.951 142.576Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M117.44 130.403C117.327 130.254 117.357 130.042 117.506 129.93C117.655 129.817 117.867 129.847 117.979 129.996L120.013 132.695C120.125 132.844 120.095 133.056 119.946 133.168C119.797 133.28 119.586 133.25 119.473 133.101L117.44 130.403Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M117.44 130.403C117.327 130.254 117.357 130.042 117.506 129.93C117.655 129.817 117.867 129.847 117.979 129.996L120.013 132.695C120.125 132.844 120.095 133.056 119.946 133.168C119.797 133.28 119.586 133.25 119.473 133.101L117.44 130.403Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M130.346 117.626C130.199 117.511 130.173 117.299 130.288 117.152C130.403 117.005 130.615 116.979 130.762 117.093L133.425 119.174C133.572 119.289 133.598 119.501 133.483 119.648C133.368 119.795 133.156 119.821 133.009 119.706L130.346 117.626Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M130.346 117.626C130.199 117.511 130.173 117.299 130.288 117.152C130.403 117.005 130.615 116.979 130.762 117.093L133.425 119.174C133.572 119.289 133.598 119.501 133.483 119.648C133.368 119.795 133.156 119.821 133.009 119.706L130.346 117.626Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M124.569 124.695C124.439 124.56 124.443 124.346 124.577 124.217C124.711 124.087 124.925 124.091 125.055 124.225L127.402 126.656C127.532 126.79 127.528 127.004 127.394 127.133C127.26 127.263 127.046 127.259 126.916 127.125L124.569 124.695Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M124.569 124.695C124.439 124.56 124.443 124.346 124.577 124.217C124.711 124.087 124.925 124.091 125.055 124.225L127.402 126.656C127.532 126.79 127.528 127.004 127.394 127.133C127.26 127.263 127.046 127.259 126.916 127.125L124.569 124.695Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M139.855 102.094C139.68 102.027 139.593 101.832 139.66 101.658C139.727 101.483 139.922 101.396 140.097 101.463L143.251 102.674C143.425 102.741 143.513 102.936 143.446 103.111C143.379 103.285 143.183 103.372 143.009 103.305L139.855 102.094Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M139.855 102.094C139.68 102.027 139.593 101.832 139.66 101.658C139.727 101.483 139.922 101.396 140.097 101.463L143.251 102.674C143.425 102.741 143.513 102.936 143.446 103.111C143.379 103.285 143.183 103.372 143.009 103.305L139.855 102.094Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M144.605 84.1455C144.42 84.1228 144.288 83.9542 144.311 83.769C144.333 83.5838 144.502 83.452 144.687 83.4748L148.041 83.8866C148.226 83.9093 148.358 84.0779 148.335 84.2631C148.313 84.4484 148.144 84.5801 147.959 84.5573L144.605 84.1455Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M144.605 84.1455C144.42 84.1228 144.288 83.9542 144.311 83.769C144.333 83.5838 144.502 83.452 144.687 83.4748L148.041 83.8866C148.226 83.9093 148.358 84.0779 148.335 84.2631C148.313 84.4484 148.144 84.5801 147.959 84.5573L144.605 84.1455Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M142.906 92.9593C142.726 92.911 142.619 92.7257 142.668 92.5454C142.716 92.3652 142.901 92.2582 143.081 92.3065L146.345 93.1811C146.525 93.2294 146.632 93.4146 146.584 93.5949C146.536 93.7752 146.351 93.8821 146.17 93.8338L142.906 92.9593Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M142.906 92.9593C142.726 92.911 142.619 92.7257 142.668 92.5454C142.716 92.3652 142.901 92.2582 143.081 92.3065L146.345 93.1811C146.525 93.2294 146.632 93.4146 146.584 93.5949C146.536 93.7752 146.351 93.8821 146.17 93.8338L142.906 92.9593Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M149 73.9719V75.3235H144.945V73.9719H149Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M149 73.9719V75.3235H144.945V73.9719H149Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M144.698 65.8155C144.513 65.8415 144.342 65.7127 144.316 65.5279C144.29 65.3431 144.419 65.1723 144.604 65.1463L147.95 64.676C148.135 64.6501 148.306 64.7788 148.332 64.9636C148.358 65.1484 148.229 65.3193 148.044 65.3453L144.698 65.8155Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M144.698 65.8155C144.513 65.8415 144.342 65.7127 144.316 65.5279C144.29 65.3431 144.419 65.1723 144.604 65.1463L147.95 64.676C148.135 64.6501 148.306 64.7788 148.332 64.9636C148.358 65.1484 148.229 65.3193 148.044 65.3453L144.698 65.8155Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M140.121 48.0557C139.951 48.1316 139.751 48.0549 139.675 47.8845C139.599 47.714 139.676 47.5142 139.846 47.4383L142.933 46.064C143.104 45.9881 143.303 46.0647 143.379 46.2352C143.455 46.4057 143.379 46.6054 143.208 46.6813L140.121 48.0557Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M140.121 48.0557C139.951 48.1316 139.751 48.0549 139.675 47.8845C139.599 47.714 139.676 47.5142 139.846 47.4383L142.933 46.064C143.104 45.9881 143.303 46.0647 143.379 46.2352C143.455 46.4057 143.379 46.6054 143.208 46.6813L140.121 48.0557Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M143.072 56.6051C142.891 56.6502 142.708 56.54 142.662 56.3589C142.617 56.1779 142.727 55.9945 142.909 55.9493L146.187 55.1319C146.368 55.0867 146.552 55.1969 146.597 55.378C146.642 55.5591 146.532 55.7425 146.351 55.7876L143.072 56.6051Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M143.072 56.6051C142.891 56.6502 142.708 56.54 142.662 56.3589C142.617 56.1779 142.727 55.9945 142.909 55.9493L146.187 55.1319C146.368 55.0867 146.552 55.1969 146.597 55.378C146.642 55.5591 146.532 55.7425 146.351 55.7876L143.072 56.6051Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M138.621 37.1408L139.317 38.2994L135.842 40.3877L135.145 39.2292L138.621 37.1408Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M138.621 37.1408L139.317 38.2994L135.842 40.3877L135.145 39.2292L138.621 37.1408Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M131.073 32.0083C130.918 32.1127 130.708 32.0718 130.604 31.9171C130.5 31.7624 130.54 31.5524 130.695 31.4481L133.497 29.5585C133.651 29.4542 133.861 29.495 133.966 29.6497C134.07 29.8044 134.029 30.0144 133.874 30.1188L131.073 32.0083Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M131.073 32.0083C130.918 32.1127 130.708 32.0718 130.604 31.9171C130.5 31.7624 130.54 31.5524 130.695 31.4481L133.497 29.5585C133.651 29.4542 133.861 29.495 133.966 29.6497C134.07 29.8044 134.029 30.0144 133.874 30.1188L131.073 32.0083Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M117.978 18.8608C117.863 19.0079 117.65 19.0339 117.503 18.919C117.356 18.8042 117.33 18.5918 117.445 18.4447L119.525 15.7821C119.64 15.635 119.853 15.6089 120 15.7238C120.147 15.8387 120.173 16.0511 120.058 16.1981L117.978 18.8608Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M117.978 18.8608C117.863 19.0079 117.65 19.0339 117.503 18.919C117.356 18.8042 117.33 18.5918 117.445 18.4447L119.525 15.7821C119.64 15.635 119.853 15.6089 120 15.7238C120.147 15.8387 120.173 16.0511 120.058 16.1981L117.978 18.8608Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M125.042 24.9646C124.906 25.0919 124.692 25.0844 124.564 24.9479C124.437 24.8115 124.445 24.5976 124.581 24.4704L127.052 22.1659C127.189 22.0386 127.403 22.0461 127.53 22.1826C127.657 22.3191 127.65 22.5329 127.513 22.6602L125.042 24.9646Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M125.042 24.9646C124.906 25.0919 124.692 25.0844 124.564 24.9479C124.437 24.8115 124.445 24.5976 124.581 24.4704L127.052 22.1659C127.189 22.0386 127.403 22.0461 127.53 22.1826C127.657 22.3191 127.65 22.5329 127.513 22.6602L125.042 24.9646Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M102.112 9.72482C102.036 9.8953 101.836 9.97198 101.666 9.89607C101.495 9.82017 101.419 9.62043 101.495 9.44995L102.869 6.36308C102.945 6.1926 103.145 6.11593 103.315 6.19183C103.486 6.26774 103.562 6.46747 103.486 6.63796L102.112 9.72482Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M102.112 9.72482C102.036 9.8953 101.836 9.97198 101.666 9.89607C101.495 9.82017 101.419 9.62043 101.495 9.44995L102.869 6.36308C102.945 6.1926 103.145 6.11593 103.315 6.19183C103.486 6.26774 103.562 6.46747 103.486 6.63796L102.112 9.72482Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M84.8556 5.08193C84.8426 5.26809 84.6811 5.40845 84.495 5.39544C84.3088 5.38242 84.1684 5.22095 84.1814 5.03479L84.4172 1.66402C84.4302 1.47786 84.5916 1.3375 84.7778 1.35052C84.964 1.36354 85.1043 1.525 85.0913 1.71117L84.8556 5.08193Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M84.8556 5.08193C84.8426 5.26809 84.6811 5.40845 84.495 5.39544C84.3088 5.38242 84.1684 5.22095 84.1814 5.03479L84.4172 1.66402C84.4302 1.47786 84.5916 1.3375 84.7778 1.35052C84.964 1.36354 85.1043 1.525 85.0913 1.71117L84.8556 5.08193Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M93.6444 6.78706C93.6024 6.9689 93.421 7.08227 93.2391 7.04029C93.0573 6.99831 92.9439 6.81688 92.9859 6.63504L93.746 3.34265C93.788 3.16082 93.9694 3.04744 94.1513 3.08942C94.3331 3.1314 94.4465 3.31284 94.4045 3.49467L93.6444 6.78706Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M93.6444 6.78706C93.6024 6.9689 93.421 7.08227 93.2391 7.04029C93.0573 6.99831 92.9439 6.81688 92.9859 6.63504L93.746 3.34265C93.788 3.16082 93.9694 3.04744 94.1513 3.08942C94.3331 3.1314 94.4465 3.31284 94.4045 3.49467L93.6444 6.78706Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M111.791 10.0863L112.898 10.8615L110.572 14.183L109.465 13.4078L111.791 10.0863Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M111.791 10.0863L112.898 10.8615L110.572 14.183L109.465 13.4078L111.791 10.0863Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M75.6758 144.594H74.3242V148.648H75.6758V144.594Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M75.6758 144.594H74.3242V148.648H75.6758V144.594Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M40.5332 135.47L39.3627 134.794L37.3353 138.306L38.5058 138.982L40.5332 135.47Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M40.5332 135.47L39.3627 134.794L37.3353 138.306L38.5058 138.982L40.5332 135.47Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.5156 110.247L13.7795 109.113L10.3789 111.322L11.115 112.455L14.5156 110.247Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.5156 110.247L13.7795 109.113L10.3789 111.322L11.115 112.455L14.5156 110.247Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M66.1444 144.326C66.1639 144.14 66.0292 143.974 65.8436 143.955C65.658 143.935 65.4918 144.07 65.4723 144.255L65.1191 147.616C65.0996 147.801 65.2342 147.968 65.4198 147.987C65.6054 148.007 65.7717 147.872 65.7912 147.686L66.1444 144.326Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M66.1444 144.326C66.1639 144.14 66.0292 143.974 65.8436 143.955C65.658 143.935 65.4918 144.07 65.4723 144.255L65.1191 147.616C65.0996 147.801 65.2342 147.968 65.4198 147.987C65.6054 148.007 65.7717 147.872 65.7912 147.686L66.1444 144.326Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M48.2903 139.802C48.3662 139.631 48.2895 139.432 48.119 139.356C47.9486 139.28 47.7488 139.356 47.6729 139.527L46.2986 142.614C46.2227 142.784 46.2993 142.984 46.4698 143.06C46.6403 143.136 46.84 143.059 46.9159 142.889L48.2903 139.802Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M48.2903 139.802C48.3662 139.631 48.2895 139.432 48.119 139.356C47.9486 139.28 47.7488 139.356 47.6729 139.527L46.2986 142.614C46.2227 142.784 46.2993 142.984 46.4698 143.06C46.6403 143.136 46.84 143.059 46.9159 142.889L48.2903 139.802Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M57.049 142.576C57.091 142.394 56.9776 142.213 56.7958 142.171C56.6139 142.129 56.4325 142.242 56.3905 142.424L55.6304 145.716C55.5884 145.898 55.7018 146.08 55.8836 146.122C56.0655 146.164 56.2469 146.05 56.2889 145.868L57.049 142.576Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M57.049 142.576C57.091 142.394 56.9776 142.213 56.7958 142.171C56.6139 142.129 56.4325 142.242 56.3905 142.424L55.6304 145.716C55.5884 145.898 55.7018 146.08 55.8836 146.122C56.0655 146.164 56.2469 146.05 56.2889 145.868L57.049 142.576Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M32.5603 130.403C32.6726 130.254 32.6429 130.042 32.4938 129.93C32.3448 129.817 32.1329 129.847 32.0206 129.996L29.9871 132.695C29.8748 132.844 29.9045 133.056 30.0536 133.168C30.2026 133.28 30.4145 133.25 30.5268 133.101L32.5603 130.403Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M32.5603 130.403C32.6726 130.254 32.6429 130.042 32.4938 129.93C32.3448 129.817 32.1329 129.847 32.0206 129.996L29.9871 132.695C29.8748 132.844 29.9045 133.056 30.0536 133.168C30.2026 133.28 30.4145 133.25 30.5268 133.101L32.5603 130.403Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M19.6537 117.626C19.8007 117.511 19.8268 117.299 19.7119 117.152C19.597 117.005 19.3846 116.979 19.2376 117.093L16.5749 119.174C16.4278 119.289 16.4018 119.501 16.5167 119.648C16.6316 119.795 16.8439 119.821 16.991 119.706L19.6537 117.626Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M19.6537 117.626C19.8007 117.511 19.8268 117.299 19.7119 117.152C19.597 117.005 19.3846 116.979 19.2376 117.093L16.5749 119.174C16.4278 119.289 16.4018 119.501 16.5167 119.648C16.6316 119.795 16.8439 119.821 16.991 119.706L19.6537 117.626Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M25.4313 124.695C25.5609 124.56 25.5572 124.346 25.423 124.217C25.2887 124.087 25.0748 124.091 24.9452 124.225L22.5979 126.656C22.4683 126.79 22.472 127.004 22.6063 127.133C22.7405 127.263 22.9544 127.259 23.084 127.125L25.4313 124.695Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M25.4313 124.695C25.5609 124.56 25.5572 124.346 25.423 124.217C25.2887 124.087 25.0748 124.091 24.9452 124.225L22.5979 126.656C22.4683 126.79 22.472 127.004 22.6063 127.133C22.7405 127.263 22.9544 127.259 23.084 127.125L25.4313 124.695Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10.1455 102.094C10.3197 102.027 10.4067 101.832 10.3398 101.658C10.273 101.483 10.0775 101.396 9.9033 101.463L6.74873 102.674C6.57451 102.741 6.48749 102.936 6.55437 103.111C6.62125 103.285 6.8167 103.372 6.99092 103.305L10.1455 102.094Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10.1455 102.094C10.3197 102.027 10.4067 101.832 10.3398 101.658C10.273 101.483 10.0775 101.396 9.9033 101.463L6.74873 102.674C6.57451 102.741 6.48749 102.936 6.55437 103.111C6.62125 103.285 6.8167 103.372 6.99092 103.305L10.1455 102.094Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.39509 84.1455C5.58031 84.1228 5.71203 83.9542 5.68929 83.769C5.66655 83.5838 5.49795 83.452 5.31273 83.4748L1.95892 83.8866C1.77369 83.9093 1.64198 84.0779 1.66472 84.2631C1.68746 84.4484 1.85605 84.5801 2.04128 84.5573L5.39509 84.1455Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.39509 84.1455C5.58031 84.1228 5.71203 83.9542 5.68929 83.769C5.66655 83.5838 5.49795 83.452 5.31273 83.4748L1.95892 83.8866C1.77369 83.9093 1.64198 84.0779 1.66472 84.2631C1.68746 84.4484 1.85605 84.5801 2.04128 84.5573L5.39509 84.1455Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.09354 92.9593C7.27379 92.911 7.38077 92.7257 7.33247 92.5454C7.28417 92.3652 7.09888 92.2582 6.91863 92.3065L3.65477 93.1811C3.47451 93.2294 3.36754 93.4146 3.41584 93.5949C3.46414 93.7752 3.64942 93.8821 3.82968 93.8338L7.09354 92.9593Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.09354 92.9593C7.27379 92.911 7.38077 92.7257 7.33247 92.5454C7.28417 92.3652 7.09888 92.2582 6.91863 92.3065L3.65477 93.1811C3.47451 93.2294 3.36754 93.4146 3.41584 93.5949C3.46414 93.7752 3.64942 93.8821 3.82968 93.8338L7.09354 92.9593Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M1 73.9719L1 75.3235H5.05479V73.9719H1Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M1 73.9719L1 75.3235H5.05479V73.9719H1Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.30211 65.8155C5.48691 65.8415 5.65777 65.7127 5.68375 65.5279C5.70972 65.3431 5.58096 65.1723 5.39616 65.1463L2.05005 64.676C1.86525 64.6501 1.69438 64.7788 1.66841 64.9636C1.64244 65.1484 1.7712 65.3193 1.956 65.3453L5.30211 65.8155Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.30211 65.8155C5.48691 65.8415 5.65777 65.7127 5.68375 65.5279C5.70972 65.3431 5.58096 65.1723 5.39616 65.1463L2.05005 64.676C1.86525 64.6501 1.69438 64.7788 1.66841 64.9636C1.64244 65.1484 1.7712 65.3193 1.956 65.3453L5.30211 65.8155Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.87881 48.0557C10.0493 48.1316 10.249 48.0549 10.3249 47.8845C10.4008 47.714 10.3242 47.5142 10.1537 47.4383L7.06682 46.064C6.89634 45.9881 6.6966 46.0647 6.6207 46.2352C6.54479 46.4057 6.62146 46.6054 6.79195 46.6813L9.87881 48.0557Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.87881 48.0557C10.0493 48.1316 10.249 48.0549 10.3249 47.8845C10.4008 47.714 10.3242 47.5142 10.1537 47.4383L7.06682 46.064C6.89634 45.9881 6.6966 46.0647 6.6207 46.2352C6.54479 46.4057 6.62146 46.6054 6.79195 46.6813L9.87881 48.0557Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.928 56.6051C7.10907 56.6502 7.29246 56.54 7.3376 56.3589C7.38275 56.1779 7.27256 55.9945 7.09149 55.9493L3.81286 55.1319C3.63179 55.0867 3.4484 55.1969 3.40325 55.378C3.35811 55.5591 3.4683 55.7425 3.64937 55.7876L6.928 56.6051Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.928 56.6051C7.10907 56.6502 7.29246 56.54 7.3376 56.3589C7.38275 56.1779 7.27256 55.9945 7.09149 55.9493L3.81286 55.1319C3.63179 55.0867 3.4484 55.1969 3.40325 55.378C3.35811 55.5591 3.4683 55.7425 3.64937 55.7876L6.928 56.6051Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M11.3789 37.1408L10.6828 38.2994L14.1584 40.3877L14.8545 39.2292L11.3789 37.1408Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M11.3789 37.1408L10.6828 38.2994L14.1584 40.3877L14.8545 39.2292L11.3789 37.1408Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M18.9269 32.0083C19.0816 32.1127 19.2916 32.0718 19.396 31.9171C19.5003 31.7624 19.4595 31.5524 19.3048 31.4481L16.5035 29.5585C16.3488 29.4542 16.1388 29.495 16.0344 29.6497C15.9301 29.8044 15.9709 30.0144 16.1256 30.1188L18.9269 32.0083Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M18.9269 32.0083C19.0816 32.1127 19.2916 32.0718 19.396 31.9171C19.5003 31.7624 19.4595 31.5524 19.3048 31.4481L16.5035 29.5585C16.3488 29.4542 16.1388 29.495 16.0344 29.6497C15.9301 29.8044 15.9709 30.0144 16.1256 30.1188L18.9269 32.0083Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M32.0224 18.8608C32.1373 19.0079 32.3497 19.0339 32.4967 18.919C32.6438 18.8042 32.6699 18.5918 32.555 18.4447L30.4747 15.7821C30.3598 15.635 30.1474 15.6089 30.0004 15.7238C29.8533 15.8387 29.8272 16.0511 29.9421 16.1981L32.0224 18.8608Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M32.0224 18.8608C32.1373 19.0079 32.3497 19.0339 32.4967 18.919C32.6438 18.8042 32.6699 18.5918 32.555 18.4447L30.4747 15.7821C30.3598 15.635 30.1474 15.6089 30.0004 15.7238C29.8533 15.8387 29.8272 16.0511 29.9421 16.1981L32.0224 18.8608Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M24.958 24.9646C25.0944 25.0919 25.3083 25.0844 25.4355 24.9479C25.5628 24.8115 25.5553 24.5976 25.4188 24.4704L22.9476 22.1659C22.8111 22.0386 22.5973 22.0461 22.47 22.1826C22.3428 22.3191 22.3502 22.5329 22.4867 22.6602L24.958 24.9646Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M24.958 24.9646C25.0944 25.0919 25.3083 25.0844 25.4355 24.9479C25.5628 24.8115 25.5553 24.5976 25.4188 24.4704L22.9476 22.1659C22.8111 22.0386 22.5973 22.0461 22.47 22.1826C22.3428 22.3191 22.3502 22.5329 22.4867 22.6602L24.958 24.9646Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M47.888 9.72482C47.9639 9.8953 48.1636 9.97198 48.3341 9.89607C48.5046 9.82017 48.5812 9.62043 48.5053 9.44995L47.131 6.36308C47.0551 6.1926 46.8553 6.11593 46.6848 6.19183C46.5144 6.26774 46.4377 6.46747 46.5136 6.63796L47.888 9.72482Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M47.888 9.72482C47.9639 9.8953 48.1636 9.97198 48.3341 9.89607C48.5046 9.82017 48.5812 9.62043 48.5053 9.44995L47.131 6.36308C47.0551 6.1926 46.8553 6.11593 46.6848 6.19183C46.5144 6.26774 46.4377 6.46747 46.5136 6.63796L47.888 9.72482Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M65.1444 5.08193C65.1574 5.26809 65.3189 5.40845 65.505 5.39544C65.6912 5.38242 65.8316 5.22095 65.8186 5.03479L65.5828 1.66402C65.5698 1.47786 65.4084 1.3375 65.2222 1.35052C65.036 1.36354 64.8957 1.525 64.9087 1.71117L65.1444 5.08193Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M65.1444 5.08193C65.1574 5.26809 65.3189 5.40845 65.505 5.39544C65.6912 5.38242 65.8316 5.22095 65.8186 5.03479L65.5828 1.66402C65.5698 1.47786 65.4084 1.3375 65.2222 1.35052C65.036 1.36354 64.8957 1.525 64.9087 1.71117L65.1444 5.08193Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M56.3556 6.78706C56.3976 6.9689 56.579 7.08227 56.7609 7.04029C56.9427 6.99831 57.0561 6.81688 57.0141 6.63504L56.254 3.34265C56.212 3.16082 56.0306 3.04744 55.8487 3.08942C55.6669 3.1314 55.5535 3.31284 55.5955 3.49467L56.3556 6.78706Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M56.3556 6.78706C56.3976 6.9689 56.579 7.08227 56.7609 7.04029C56.9427 6.99831 57.0561 6.81688 57.0141 6.63504L56.254 3.34265C56.212 3.16082 56.0306 3.04744 55.8487 3.08942C55.6669 3.1314 55.5535 3.31284 55.5955 3.49467L56.3556 6.78706Z",
      stroke: "white"
    })), /*#__PURE__*/_react["default"].createElement("g", {
      opacity: "0.6"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M38.209 10.0863L37.1018 10.8615L39.4276 14.183L40.5347 13.4078L38.209 10.0863Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M38.209 10.0863L37.1018 10.8615L39.4276 14.183L40.5347 13.4078L38.209 10.0863Z",
      stroke: "white"
    }))), /*#__PURE__*/_react["default"].createElement("path", {
      opacity: "0.3",
      d: "M121.017 73.4442C121.017 98.7241 100.479 119.218 75.1427 119.218C49.8068 119.218 29.2688 98.7241 29.2688 73.4442C29.2688 48.1644 49.8068 27.6703 75.1427 27.6703C100.479 27.6703 121.017 48.1644 121.017 73.4442Z",
      stroke: "white",
      strokeWidth: "0.432058"
    }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
      id: "paint0_linear",
      x1: "75.1416",
      y1: "124.96",
      x2: "75.1416",
      y2: "21.9227",
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/_react["default"].createElement("stop", {
      stopColor: "#808080",
      stopOpacity: "0.25"
    }), /*#__PURE__*/_react["default"].createElement("stop", {
      offset: "0.54",
      stopColor: "#808080",
      stopOpacity: "0.12"
    }), /*#__PURE__*/_react["default"].createElement("stop", {
      offset: "1",
      stopColor: "#808080",
      stopOpacity: "0.1"
    }))))
    /* eslint-enable */
  );
};

Clock.defaultProps = {
  background: null,
  forwardedRef: null
};
Clock.propTypes = {
  background: _propTypes["default"].string,
  forwardedRef: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
  theme: _propTypes["default"].object.isRequired
};
var _default = (0, _oxygenConfig.withTheme)(Clock, 'graphics');
exports["default"] = _default;